import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';

// Angular Material
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

// Teller Online Libraries
import { TellerOnlineSharedModule } from 'teller-online-libraries/shared';

// Components
import { TellerOnlineHelpComponent, TellerOnlineHelpSidebarComponent } from './components';

@NgModule({
    declarations: [
        TellerOnlineHelpComponent,
        TellerOnlineHelpSidebarComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        MatCardModule,
        MatDividerModule,
        MatFormFieldModule,
        MatInputModule,
        MatButtonModule,
        MatToolbarModule,
        MatIconModule,
        MatTooltipModule,
        TellerOnlineSharedModule
    ],
    exports: [
        TellerOnlineHelpComponent,
        TellerOnlineHelpSidebarComponent
    ]
})
export class TellerOnlineHelpModule {}
